import {
  AggressorDetails,
  relationShip,
} from "@modules/plaintes/plaintes.model.ts";
import React from "react";
import { AgeFormat } from "./victimInfo.tsx";
import { classNames } from "primereact/utils";
interface AggressorProps {
  aggressors: AggressorDetails[];
}
const AggressorInfo: React.FC<AggressorProps> = ({ aggressors }) => {
  const relationAgressorVictim = (aggressorRelation: string) => {
    const relationWithVictim = relationShip.filter(
      (aggressor) => aggressor.code === aggressorRelation
    );
    return relationWithVictim[0].name;
  };

  return (
    <div className="rounded-[10px] p-4 bg-white flex flex-col">
      <span className="text-black text-sm font-semibold">
        Information sur le présumé auteur :
      </span>
      {aggressors.map((aggressor, index) => (
        <div
          key={aggressor.id}
          className={classNames("w-full flex items-center", {
            "border-b border-solid pb-2":
              aggressors.length > 1 && index !== aggressors.length - 1,
          })}
        >
          <div className="gap-2 flex flex-col mt-2">
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Nom : &nbsp;
              </span>
              <span className="text-black text-sm">{aggressor.lastName}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Prénom(s) : &nbsp;
              </span>
              <span className="text-black text-sm">{aggressor.firstName}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Adresse : &nbsp;
              </span>
              <span className="text-black text-sm">{aggressor.address}</span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Sexe : &nbsp;
              </span>
              <span className="text-black text-sm">
                {aggressor.gender === "FEMALE" ? "Féminin" : "Masculin"}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Age : &nbsp;
              </span>
              <span className="text-black text-sm">
                {AgeFormat(aggressor.ageGroup)}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Nationalité : &nbsp;
              </span>
              <span className="text-black text-sm">
                {aggressor.nationality}
              </span>
            </div>
            <div className="flex items-baseline">
              <span className="text-[#6C757D] text-sm font-semibold">
                Relation avec la victime : &nbsp;
              </span>
              <span className="text-black text-sm">
                {relationAgressorVictim(aggressor.victimRelationShip)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AggressorInfo;
